import styled from 'styled-components';
import { Modal, TypographyComponent } from '@tvg/fuse-design';

export const Dialog = styled(Modal)`
  .fuse-modal__footer {
    display: none; // There is a bug in the modal where the footer is shown when it shouldn't be
  }
`;

export const DialogSection = styled.section`
  margin-bottom: var(--spacing-space16);

  &:last-child {
    margin-bottom: 0;
  }
`;

export const DialogHeading = styled(TypographyComponent)`
  margin-bottom: var(--spacing-space12);
`;

export const DialogText = styled(TypographyComponent)`
  strong {
    color: var(--color-greys-grey10);
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

export const DialogList = styled.ul`
  list-style-type: square;
  padding-left: var(--spacing-space16);
`;
